import React, { useState } from "react";
import Image, { ImageProps } from "next/image";

export const ImageWithSkeleton: React.FC<
  ImageProps & {
    isHovered?: boolean;
    useHoverEffect?: boolean;
  }
> = ({
  alt,
  height,
  width,
  onMouseEnter,
  onMouseLeave,
  isHovered,
  className,
  quality,
  useHoverEffect = true,
  style,
  priority,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div
      className={`relative isolate flex items-center overflow-hidden after:absolute after:inset-0 after:z-10 after:transition-colors after:ease-in-out ${
        useHoverEffect && isHovered ? "after:bg-black/20" : ""
      } ${useHoverEffect && !isHovered ? "after:bg-transparent hover:after:bg-black/20" : ""} ${className}`}
      onMouseEnter={useHoverEffect ? onMouseEnter : () => {}}
      onMouseLeave={useHoverEffect ? onMouseLeave : () => {}}
    >
      <Image
        alt={alt}
        width={width}
        height={height}
        onLoad={() => setLoaded(true)}
        {...props}
        placeholder="blur"
        quality={quality ?? 75}
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8fg0AAqoBv8IAnAMAAAAASUVORK5CYII="
        style={{
          ...style,
          objectFit: "cover",
        }}
        priority={priority ?? false}
        className={className}
      />
    </div>
  );
};
